export class AddIndustryProductDiscount {
  private industryDiscountId: string;
  private ean: string;
  private userDiscount: number;
  private directDiscount: number;
  private indirectDiscount: number;

  public getIndustryDiscountId(): string {
    return this.industryDiscountId;
  }

  public getEan(): string {
    return this.ean;
  }

  public getUserDiscount(): number {
    return this.userDiscount;
  }

  public getDirectDiscount(): number {
    return this.directDiscount;
  }

  public getIndirectDiscount(): number {
    return this.indirectDiscount;
  }

  public setIndustryDiscountId(value: string) {
    this.industryDiscountId = value;
  }

  public setEan(value: string) {
    this.ean = value;
  }

  public setUserDiscount(value: number) {
    this.userDiscount = value;
  }

  public setDirectDiscount(value: number) {
    this.directDiscount = value;
  }

  public setIndirectDiscount(value: number) {
    this.indirectDiscount = value;
  }
}
